import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getSalesInvoiceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SALES_INVOICE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.SALES_INVOICE_DETAILS_FAILURE });
        return error;
    }
}

export function* getSalesTransactionDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.SALES_TRANSACTION_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.SALES_TRANSACTION_DETAILS_FAILURE });
        return error;
    }
}


export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_SALES_TRANSACTION_DETAILS_SUCCESS,
    });
}


export default function* salesTransactionsSaga() {
    yield all([
        takeEvery(actions.SALES_INVOICE_DETAILS_START, getSalesInvoiceDetails),
        takeEvery(actions.SALES_TRANSACTION_DETAILS_START, getSalesTransactionDetails),
        takeEvery(actions.CLEAR_SALES_TRANSACTION_DETAILS_START, getClearDetails)
    ]);
}